import * as React from 'react'
import { Field } from 'formik'

import { MuiTextFieldFormik } from '@user/components/Formik'

export function Title() {
  return (
    <Field
      required
      fullWidth
      size="small"
      name="title"
      label="Title"
      margin="normal"
      component={MuiTextFieldFormik}
      inputProps={{ maxLength: 255 }}
    />
  )
}
